import { useQuery } from '@tanstack/react-query';
import { functions } from '@/shared/lib/supabase';
import type { ClientProduct, Product, UserProfile } from '@/shared/types';

export interface FormSubmissionRecord {
  clientProduct: ClientProduct;
  product: Product;
  userProfile: UserProfile;
  formData: Record<string, any> | null;
  submission?: any;
  form?: any; // Optionally include the `forms` table schema (id, fields) for label lookups
}

interface ListFormSubmissionsResponse {
  submissions: FormSubmissionRecord[];
}

interface UseFormSubmissionsOptions {
  statuses?: string[];
  includeArchived?: boolean;
  formId?: string | null;
}

export const useFormSubmissions = (options?: UseFormSubmissionsOptions) => {
  return useQuery<FormSubmissionRecord[]>({
    queryKey: [
      'admin-form-submissions',
      options?.statuses?.join(',') ?? 'all',
      options?.includeArchived ? 'with-archived' : 'active-only',
    ],
    queryFn: async () => {
      const payload: Record<string, any> = {};
      if (options?.statuses?.length) {
        payload.statuses = options.statuses;
      }
      if (options?.includeArchived) {
        payload.includeArchived = true;
      }
      if (options?.formId) {
        payload.formId = options?.formId;
      }

      const response = await functions.invoke<ListFormSubmissionsResponse>('list-form-submissions', {
        body: Object.keys(payload).length ? payload : undefined,
      });

      return response?.submissions ?? [];
    },
  });
};
